export const placeholder = "user_placeholder.png";
export const attachment = "attechment.png";
